module.exports = __webpack_public_path__ + "static/img/no-image-1.eb7da0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-image-1.jpg
// module id = nxgk
// module chunks = 1